import { css } from '@linaria/atomic';

const animatedBadge = css`
  color: var(--animated-badge-text, var(--fabric-color-neutral-00));
  font-size: var(--fabric-font-size-sm);
  font-weight: var(--fabric-font-weight-regular);
  border-radius: var(--fabric-radius-sm);
  height: 24px;
  width: fit-content;
  padding: 0 1px;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  @keyframes rotate {
    0% {
      transform: translate(-50%, -50%) rotate(0deg);
    }
    100% {
      transform: translate(-50%, -50%) rotate(360deg);
    }
  }

  &::before,
  &::after {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 200%;
    height: 200%;
    border-radius: var(--fabric-radius-sm);
    background-size: 100% 100%;
    background-position: 0px 0px;
    background-image: conic-gradient(
      from 0deg at 50% 50%,
      var(--animated-badge-highlight, var(--fabric-color-seaweed-20)) 8%,
      var(--animated-badge-primary, var(--fabric-color-seaweed-70)) 20%,
      var(--animated-badge-primary, var(--fabric-color-seaweed-70)) 80%,
      var(--animated-badge-highlight, var(--fabric-color-seaweed-20)) 92%,
      var(--animated-badge-highlight, var(--fabric-color-seaweed-20)) 100%
    );
    animation: rotate var(--animated-badge-speed, 1.8s) linear infinite;
  }
  &::before {
    filter: blur(var(--animated-badge-blur, 16px));
  }
`;

const animatedBadgeContent = css`
  position: relative;
  z-index: 1;
  height: 22px;
  background-color: var(--animated-badge-bg, var(--fabric-color-seaweed-50));
  border-radius: var(--fabric-radius-sm);
  color: var(--animated-badge-text, var(--fabric-color-neutral-00));
  font-size: var(--fabric-font-size-sm);
  font-weight: var(--fabric-font-weight-regular);
  text-align: center;
  white-space: nowrap;
  backdrop-filter: blur(var(--animated-badge-blur, 16px));
  padding: 0 7px;
  display: inline-flex;
  align-items: center;
  width: fit-content;
`;

const badgeContent = css`
  height: 24px;
  background-color: var(--animated-badge-bg, var(--fabric-color-seaweed-50));
  border-radius: var(--fabric-radius-sm);
  color: var(--animated-badge-text, var(--fabric-color-neutral-00));
  font-size: var(--fabric-font-size-sm);
  font-weight: var(--fabric-font-weight-regular);
  text-align: center;
  white-space: nowrap;
  padding: 2px 8px;
  width: fit-content;
  flex-shrink: 0;
`;

export const AnimatedBadgeStyles = {
  animatedBadge,
  animatedBadgeContent,
  badgeContent,
};
